// extracted by mini-css-extract-plugin
export var addressFields = "_mz-0";
export var animationContainer = "_mz-1";
export var footer = "_mz-2";
export var lineItems = "_mz-3";
export var modalContent = "_mz-4";
export var orderName = "_mz-5";
export var strong = "_mz-6";
export var warning = "_mz-7";